import { LeaveType } from "@/models/leave-types.model";
import apiClient from "./apiClient";

export const getLeaveTypes = async (): Promise<LeaveType[]> => {
  const res = await apiClient.get("/leave-types");
  const data: LeaveType[] = res.data as LeaveType[];
  return data;
};
